import { useEffect } from "react";
import { useVideoPlayerRefs } from "../contexts/VideoPlayerRefs";
import { Ratio, VideoTime } from "../types/videoTime";

export type TimeUpdate = VideoTime & Ratio;
export type TimeUpdateCallback = (timeUpdate: TimeUpdate) => void;

const getTimeUpdate = (element: HTMLVideoElement): TimeUpdate => {
  const { currentTime, duration } = element;
  const ratio = currentTime / duration;
  return { currentTime, ratio, duration };
};

export const useTimeUpdateEvent = (
  on: boolean,
  callback: TimeUpdateCallback
) => {
  const { video } = useVideoPlayerRefs();

  useEffect(() => {
    if (video.current !== null && on) {
      const videoElement = video.current;
      let rafHandler: number;

      const handler = () => {
        window.cancelAnimationFrame(rafHandler);
        callback(getTimeUpdate(videoElement));

        rafHandler = window.requestAnimationFrame(handler);
      };

      rafHandler = window.requestAnimationFrame(handler);

      return () => {
        window.cancelAnimationFrame(rafHandler);
      };
    }

    return undefined;
  }, [callback, on, video]);
};
